import { GetToursDataResponse } from 'services/api/type/report.type';
import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';
import get from 'lodash/get';
import { PaginationType } from 'services/api/type/booking.type';

export const useGetTourDetail = (tourId: number) => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_TOUR_DETAIL, tourId],
    queryFn: () => API.report.getTourDataDetails(tourId),
    enabled: !!tourId
  });

  return {
    data: get(data, 'data.data', {}) as GetToursDataResponse,
    pagination: get(data, 'data.pagination', {}) as PaginationType,
    status,
    isLoading,
    isFetching
  };
};
